import React from 'react';
import { LinkProps } from 'types/components.types';

const Link: React.FC<LinkProps> = ({ 
  children, 
  href, 
  onClick, 
  variant = 'primary',
  className = '',
  disabled = false,
  ...props 
}) => {
  const variantClasses: Record<'primary' | 'secondary' | 'muted', string> = {
    primary: 'text-teal-600 hover:text-teal-700',
    secondary: 'text-gray-600 hover:text-gray-800',
    muted: 'text-gray-500 hover:text-gray-700'
  };

  const classes = `${variantClasses[variant]} transition-colors duration-200 cursor-pointer ${
    disabled ? 'opacity-50 cursor-not-allowed' : ''
  } ${className}`;

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={classes}
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    );
  }

  return (
    <a
      href={href}
      className={classes}
      {...props}
    >
      {children}
    </a>
  );
};

export default Link;
